import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { ProjectSupportRoutingModule } from './projectSupport-routing.module';

import { ProjectSupportComponent } from './projectSupport.component';
import { ViewDrawingsComponent } from './viewDrawings.component';
import { DrawingComponent } from './drawing.component';
import { ViewOpenCarsComponent } from './qualityControl/observations/view-open-cars/view-open-cars.component';
import { ViewClosedCarsComponent } from './qualityControl/observations/view-closed-cars/view-closed-cars.component';
import { ViewNotValidCarsComponent } from './qualityControl/observations/view-not-valid-cars/view-not-valid-cars.component';
import { ViewOpenCdisComponent } from './qualityControl/observations/view-open-cdis/view-open-cdis.component';
import { ViewClosedCdisComponent } from './qualityControl/observations/view-closed-cdis/view-closed-cdis.component';
import { ViewNotValidCdisComponent } from './qualityControl/observations/view-not-valid-cdis/view-not-valid-cdis.component';
import { ObservationComponent } from './qualityControl/observations/observation/observation.component';
import { ViewWasteDrumsComponent } from './viewWasteDrums.component';
import { EnvironmentalConfigComponent } from './environmental-config/environmental-config.component';
import { OaProjectsComponent } from './engineering/oa-projects/oa-projects.component';
import { OaComponent } from './engineering/oa/oa.component';
import { EngineeringConfigComponent } from './engineering/engineering-config/engineering-config.component';
import { QualityControlConfigComponent } from './qualityControl/quality-control-config/quality-control-config.component';
import { ReportScheduleComponent } from './qualityControl/report-schedule/report-schedule.component';
import { ReportScheduleAsRequiredComponent } from './qualityControl/report-schedule-as-required/report-schedule-as-required.component';
import { QuestionComponent } from './qualityControl/checklist/question.component';
import { InspectionReportComponent } from './qualityControl/inspection-report/inspection-report.component';
import { ViewInpectionReportsComponent } from './qualityControl/inspection-report/view-inspection-reports.component';
import { WasteDrumsPopupComponent } from './qualityControl/waste-drums-popup/waste-drums-popup.component';
import { QcAreasComponent } from './qualityControl/quality-control-config/qc-areas/qc-areas.component';
import { QcContractNumbersComponent } from './qualityControl/quality-control-config/qc-contract-numbers/qc-contract-numbers.component';
import { QcDeficiencyTypeComponent } from './qualityControl/quality-control-config/qc-deficiency-type/qc-deficiency-type.component';
import { QcObservationCommentTypesComponent } from './qualityControl/quality-control-config/qc-observation-comment-types/qc-observation-comment-types.component';
import { QcOriginTypesComponent } from './qualityControl/quality-control-config/qc-origin-types/qc-origin-types.component';
import { QcRootCausesComponent } from './qualityControl/quality-control-config/qc-root-causes/qc-root-causes.component';
import { QcResponsibleManagerComponent } from './qualityControl/quality-control-config/qc-responsible-manager/qc-responsible-manager.component';
import { QcPubIndexTypesComponent } from './qualityControl/quality-control-config/qc-pub-index-types/qc-pub-index-types.component';
import { QcPublicationsComponent } from './qualityControl/quality-control-config/qc-publications/qc-publications.component';
import { QcMasterReportListingComponent } from './qualityControl/quality-control-config/qc-master-report-listing/qc-master-report-listing.component';
import { QcReportScheduleFreqComponent } from './qualityControl/quality-control-config/qc-report-schedule-freq/qc-report-schedule-freq.component';
import { QcInspectionReferencesComponent } from './qualityControl/quality-control-config/qc-inspection-references/qc-inspection-references.component';
import { QcInspectionSequencesComponent } from './qualityControl/quality-control-config/qc-inspection-sequences/qc-inspection-sequences.component';
import { QcResponsibleAssignmentsComponent } from './qualityControl/quality-control-config/qc-responsible-assignments/qc-responsible-assignments.component';
import { RebuttalCommentDialogComponent } from './qualityControl/observations/observation/rebuttal-comment-dialog/rebuttal-comment-dialog.component';


@NgModule({
  imports: [
    SharedModule,
    ProjectSupportRoutingModule
  ],
  declarations: [
    ProjectSupportComponent,
    ViewDrawingsComponent,
    DrawingComponent,
    ViewOpenCarsComponent,
    ViewClosedCarsComponent,
    ViewOpenCdisComponent,
    ViewClosedCdisComponent,
    ViewNotValidCarsComponent,
    ViewNotValidCdisComponent,
    ObservationComponent,
    ViewWasteDrumsComponent,
    EnvironmentalConfigComponent,
    OaProjectsComponent,
    OaComponent,
    EngineeringConfigComponent,
    QualityControlConfigComponent,
    ReportScheduleComponent,
    ReportScheduleAsRequiredComponent,
    QuestionComponent,
    InspectionReportComponent,
    ViewInpectionReportsComponent,
    WasteDrumsPopupComponent,
    QcAreasComponent,
    QcContractNumbersComponent,
    QcDeficiencyTypeComponent,
    QcObservationCommentTypesComponent,
    QcOriginTypesComponent,
    QcRootCausesComponent,
    QcResponsibleManagerComponent,
    QcPubIndexTypesComponent,
    QcPublicationsComponent,
    QcMasterReportListingComponent,
    QcReportScheduleFreqComponent,
    QcInspectionReferencesComponent,
    QcInspectionSequencesComponent,
    QcResponsibleAssignmentsComponent,
    RebuttalCommentDialogComponent,
  ]
})
export class ProjectSupportModule { }
